import FJImageEnhancerCard from './FJImageEnhancerCard';
import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import { setSliceImageEnhancerDataAction } from '../../../redux/slices/FJSliceImageManipulation';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

const FJImageEnhancerCardContainer = props => {
    const { disabled, style } = props;
    useLocalStore();
    const dispatch = useDispatch();
    const imageEnhancerData = useSelector(state => state.imageManipulation.imageEnhancerData);
    const uploadImageInfo = useSelector(state => state.imageManipulation.uploadImageInfo);
    const { switch: active, upscale, imageType } = imageEnhancerData;
    const imageEnhancerNum = useSelector(state => state.imageManipulation.useNumFunctionData.imageEnhancer);

    const _onSwitch = value => {
        dispatch(setSliceImageEnhancerDataAction({ ...imageEnhancerData, switch: value }));
    };
    const _onChangeZoom = value => {
        dispatch(setSliceImageEnhancerDataAction({ ...imageEnhancerData, upscale: value }));
    };
    const _onChangeImageType = value => {
        dispatch(setSliceImageEnhancerDataAction({ ...imageEnhancerData, imageType: value }));
    };

    const useDisabled = useMemo(() => {
        return imageEnhancerNum !== 0 || disabled;
    }, [imageEnhancerNum, disabled]);

    return (
        <FJImageEnhancerCard
            imageEnhancerData={imageEnhancerData}
            uploadImageInfo={uploadImageInfo}
            onSwitch={_onSwitch}
            onChangeZoom={_onChangeZoom}
            active={active}
            upscale={upscale}
            onChangeImageType={_onChangeImageType}
            imageType={imageType}
            disabled={useDisabled}
            style={style}
        />
    );
};

FJImageEnhancerCardContainer.propTypes = {
    disabled: PropTypes.bool,
    style: PropTypes.object,
};

export default FJImageEnhancerCardContainer;
